import { BRACKETS, COLOR_ID_SLUGS } from '@/utils/constants'
import useDirectories from '@/utils/useDirectories'

const getParams = ({
  subsubpage,
  subsubsubpage,
  subsubsubsubpage,
  subsubsubsubsubpage,
}: ReturnType<typeof useDirectories>) => {
  const budgets = ['budget', 'expensive']

  const params: { bracket?: string; budget?: string; colorId?: string; tag?: string } = {
    bracket: undefined,
    budget: undefined,
    colorId: undefined,
    tag: undefined,
  }

  // 1st arg can be colorId, bracket, budget, or tag
  if (!subsubpage) {
    return params
  } else if (COLOR_ID_SLUGS.includes(subsubpage)) {
    params.colorId = subsubpage
  } else if (BRACKETS.includes(subsubpage)) {
    params.bracket = subsubpage
  } else if (budgets.includes(subsubpage)) {
    params.budget = subsubpage
  } else {
    params.tag = subsubpage
  }

  // 2nd arg can be bracket, budget, or tag (not colorId)
  if (!subsubsubpage) {
    return params
  } else if (BRACKETS.includes(subsubsubpage)) {
    params.bracket = subsubsubpage
  } else if (budgets.includes(subsubsubpage)) {
    params.budget = subsubsubpage
  } else {
    params.tag = subsubsubpage
  }

  // 3rd arg can be budget or tag (not colorId or bracket)
  if (!subsubsubsubpage) {
    return params
  } else if (budgets.includes(subsubsubsubpage)) {
    params.budget = subsubsubsubpage
  } else {
    params.tag = subsubsubsubpage
  }

  // 4th arg can only be budget (not colorId, bracket, or tag)
  if (!subsubsubsubsubpage) {
    return params
  } else {
    params.budget = subsubsubsubsubpage
  }

  return params
}

export default getParams
